import { parse } from 'hub-http/helpers/params';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import { useInsightContext, INSIGHT_CONTEXT_QUERY_PARAM } from './InsightContextProviderBase';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import useEffectOnce from 'messaging-publishing-lib/hooks/useEffectOnce';
import classNames from 'classnames';
import { useHasBusinessUnitsRebrand } from 'ui-business-units-lib/hooks/useHasBusinessUnitsRebrand';
import { jsx as _jsx } from "react/jsx-runtime";
function InsightContextSelect({
  className
}) {
  const {
    availableContexts,
    context,
    setContext,
    industryName
  } = useInsightContext();
  const hasBusinessUnitsRebrand = useHasBusinessUnitsRebrand();
  const options = availableContexts.map(availableContext => ({
    value: availableContext,
    text: I18n.text(hasBusinessUnitsRebrand && availableContext === 'BUSINESS_UNIT_CONTEXT' ? `messaging-insights.insights.contexts.${availableContext}.name_buv2` : `messaging-insights.insights.contexts.${availableContext}.name`),
    help: I18n.text(hasBusinessUnitsRebrand && availableContext === 'BUSINESS_UNIT_CONTEXT' ? `messaging-insights.insights.contexts.${availableContext}.help_buv2` : `messaging-insights.insights.contexts.${availableContext}.help`, {
      industryName
    })
  }));
  useEffectOnce(() => {
    const initialValueOverride = parse(window.location.search.substring(1))[INSIGHT_CONTEXT_QUERY_PARAM];
    const isInitialValueOverrideValid = availableContexts.includes(initialValueOverride);
    if (isInitialValueOverrideValid) setContext(initialValueOverride);
  });
  const onChange = event => {
    trackInsightsInteraction({
      action: 'change-insight-context',
      insightContext: event.target.value
    });
    setContext(event.target.value);
  };

  // This one option will be filtered by removeCurrentlySelectedOption
  const hasNoOptions = options.length === 1;
  if (hasNoOptions) return null;
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    id: "post-send-insight-context-select-wrapper",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "messaging-insights.insights.contexts.label"
    }),
    className: classNames("p-right-3 m-right-7", className),
    children: /*#__PURE__*/_jsx(UISelect, {
      value: context,
      buttonUse: "transparent",
      menuWidth: 300,
      options: options,
      onChange: onChange,
      className: "insight-context-select p-all-0",
      "data-test-id": "insight-context-select"
    })
  });
}
export default InsightContextSelect;